<template>
  <div>
    <div class="row margin-half-top">
      <div class="col-md-12">
        <div class="">
          <div class="card-header">
            <btn-rounded
              label="DADOS"
              event="showView"
              params="profile"
              :fill="activeView === 'profile'"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="activeView == 'profile'">
      <div class="col-md-12">
        <div class="col-md-1">
          <button
            class="btn btn-rounded btn-fill"
            :class="[
              { ' btn-success': !localReadonly },
              { ' btn-warning': localReadonly },
            ]"
            style="padding-left: 10px; padding-right: 10px"
            v-on:click="unlock()"
          >
            <i
              :class="[
                { 'ti-unlock': !localReadonly },
                { 'ti-lock': localReadonly },
              ]"
            ></i>
          </button>
        </div>

        <!-- <div class="col-md-11">
              <button
                class="btn btn-rounded btn-fill"
                :class="[{' btn-success': !localReadonly}, {' btn-warning': localReadonly}]"
                style="padding-left: 10px; padding-right: 10px"
                v-on:click="markCar()"
              >
                  <font v-if="!isAdmin"> Marcar Carro </font>

              </button>
            </div> -->

        <div class="col-md-12">
          <car-form :data="data" :readonly="localReadonly" :edit="true" />
        </div>

        <div class="col-md-12 text-right">
          <btn-rounded label="SALVAR" event="save" v-if="!localReadonly" />
        </div>
      </div>
    </div>

    <!-- <div v-if="activeView === 'medida'">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <component-table
              eventName="selectMeasure"
              :title="table.title"
              :sub-title="table.subTitle"
              :data="data.CarImages"
              :control="table.control"
              :columns="table.columns"
              :headers="table.headers"
            />
          </div>

    
        </div>

        <div class="col-md-12 text-right">
          <btn-rounded label="SALVAR" event="saveMeasure" />
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import CarForm from "src/components/UIComponents/Forms/CarForm.vue";
import CarMeasureForm from "src/components/UIComponents/Forms/CarMeasureForm.vue";
import formConfirmButton from "src/components/UIComponents/Inputs/formConfirmButton.vue";
import ComponentTable from "components/UIComponents/Lists/ComponentTable.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import Notifications from "vue-notification";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import Vue from "vue";
import moment from "moment";

Vue.use(Notifications);
Vue.use(Viewer);

const headers = ["/", "Tipo Medida", "Outros defeitos", "Data Cadastrado"];
const tableColumns = [
  {
    columnName: "imageThumbURL",
    logic: function(data, columnData) {
      var find = true;
      if (!data) {
        find = false;
      } else if (!data.length) {
        find = false;
      } else if (!data.length > 0) {
        find = false;
      }

      console.log(data);
      console.log(columnData);

      if (find) {
        return "<img src=" + data + ' style="width:32px; height: 32px">';
      } else {
        return '<img src="https://api.carrocash.com.br/image/render/thumb/default.png" style="width:32px; height: 32px">';
      }
    },
  },
  "Measure.name",
  "OtherDefects",
  {
    columnName: "createdAt",
    logic: function(data, columnData) {
      if (!data) {
        return "";
      }
      return moment
        .utc(data)
        .utcOffset(0)
        .format("D/M/YYYY H:mm:ss");
    },
  },
];
const control = [
  {
    event: "removeCarMeasure",
    class: "ti-trash btn btn-danger btn-sm",
  },
];

export default {
  components: {
    CarForm,
    formConfirmButton,
    ComponentTable,
  },
  /**
   * Chart data used to render stats, charts. Should be replaced with server data
   */
  props: {},
  computed: {
    ...mapState({}),
  },
  watch: {
    $route: "initData",
  },
  methods: {
    ...mapActions(["updateCar", "getCar"]),
    ...mapGetters({
      sidebarFlag: "sidebarFlag",
    }),
    initData() {
      this.data = this.$route.params.id;
      this.verifyID();
      this.data.CarImages.sort((a, b) => (a.updatedAt > b.updatedAt ? 1 : -1));
      console.log(this.data);
    },

    unlock() {
      if (this.sidebarFlag() === "ADMIN") {
        this.localReadonly = !this.localReadonly;
      } else {
        this.localReadonly = true;
      }
    },

    verifyID() {
      if (this.data == undefined) {
        this.$router.push({
          name: "Anúncios - Lista",
        });
      }
    },
  },

  data() {
    return {
      localReadonly: false,
      data: null,
      readonly: true,
      measure: {},
      activeView: "profile",
      table: {
        title: "Medidas",
        subTitle: "Áreas medidas dos Veículos",
        headers: [...headers],
        columns: [...tableColumns],
        control: [...control],
      },
    };
  },

  created() {
    this.initData();
    this.localReadonly = this.readonly;

    this.$on("save", () => {
      this.updateCar(this.data)
        .then((res) => {
          this.$notify({
            group: "foo",
            title: "Sucesso",
            text: res.msg,
            position: "top center",
            type: "success",
          });
          this.localReadonly = true;
        })
        .catch((res) => {
          this.$notify({
            group: "foo",
            title: res.msg,
            text: res.info,
            position: "top center",
            type: "error",
          });
        });
    });

    this.$on("saveMeasure", () => {
      this.measure.CarId = this.data.id;

      if (this.measure.id) {
        this.updateCarMeasure(this.measure)
          .then((res) => {
            this.$notify({
              group: "foo",
              title: "Sucesso",
              text: res.msg,
              position: "top center",
              type: "success",
            });
            this.localReadonly = true;
          })
          .catch((res) => {
            this.$notify({
              group: "foo",
              title: res.msg,
              text: res.info,
              position: "top center",
              type: "error",
            });
          });
      } else {
        this.createCarMeasure(this.measure)
          .then((res) => {
            this.$notify({
              group: "foo",
              title: "Sucesso",
              text: res.msg,
              position: "top center",
              type: "success",
            });
            this.localReadonly = true;
            this.data.CarMeasures.push(res.info);
            this.measure = {};
          })
          .catch((res) => {
            this.$notify({
              group: "foo",
              title: res.msg,
              text: res.info,
              position: "top center",
              type: "error",
            });
          });
      }
    });

    this.$on("selectMeasure", (item) => {
      this.measure = item;
    });
    //this.measure = this.data

    this.$on("removeCarMeasure", (item) => {
      this.deleteCarMeasure(item)
        .then((res) => {
          this.$notify({
            group: "foo",
            title: "Sucesso",
            text: res.msg,
            position: "top center",
            type: "success",
          });

          const index = this.data.CarMeasures.indexOf(item, 0);
          if (index > -1) {
            this.CarMeasures.splice(index, 1);
          }
        })
        .catch((res) => {});
    });

    this.$on("showView", (view) => {
      this.activeView = view;
    });
  },
};
</script>
<style lang="scss" scoped>
.card-image {
  border: solid 1px white;
  padding: 15px;
  background-color: #f0f0f0;
}

.rotateimg90 {
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  transform: rotate(90deg);
}

.rotateimg180 {
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}

.rotateimg270 {
  -webkit-transform: rotate(270deg);
  -moz-transform: rotate(270deg);
  -ms-transform: rotate(270deg);
  -o-transform: rotate(270deg);
  transform: rotate(270deg);
}

.images {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Car/CarEdit.vue